<template>
  <router-view class="jm-bg-background"></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>
